import env from "../env"
import {PRODUCTION} from "../constants/environment"

/* eslint-disable */
const setup = () => {
  if (env.ENVIRONMENT_NAME === PRODUCTION) {
    // Google Tag Manager
    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"})
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : ""
      j.async = true
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, "script", "dataLayer", "GTM-W53DNG4")
    // End Google Tag Manager
  } else {
    // STAGING environment (gtm)
    // Google Tag Manager

    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js"})
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : ""
      j.async = true
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, "script", "dataLayer", "GTM-PW34Q6LW")

    // End Google Tag Manager
  }
}

export default {
  setup
}
